import { skillsApi } from '../services/api';
import { useAlert } from '../contexts/AlertContext';

const useCommentsManagement = (competencies, setCompetencies, myReviewer, employeeId) => {
  const { showAlert } = useAlert();

  const handleCommentChange = async (reviewerId, skillId, value) => {
    try {
      // Only proceed if it's the current reviewer's comment and not completed
      if (!myReviewer.completedAt && employeeId === myReviewer.employee.id) {
        await skillsApi.updateSkillMappingComments(
          reviewerId,
          skillId,
          value
        );

        setCompetencies(prev => ({
          ...prev,
          reviewers: {
            ...prev.reviewers,
            [reviewerId]: {
              ...prev.reviewers[reviewerId] || {},
              skills: {
                ...prev.reviewers[reviewerId]?.skills || {},
                [skillId]: {
                  ...prev.reviewers[reviewerId]?.skills?.[skillId] || {},
                  comments: value
                }
              }
            }
          }
        }));
        
        return Promise.resolve(); // Return resolved promise on success
      }
      return Promise.resolve(); // Still resolve if we didn't need to save
    } catch (error) {
      console.error('Error updating skill comments:', error);
      showAlert(error.message || 'Failed to save comments', 'error', error);
      return Promise.reject(error); // Reject promise on error
    }
  };

  const handleSegmentCommentChange = async (reviewerId, skillId, segmentId, mappingId, value) => {
    try {
      // Only proceed if it's the current reviewer's comment and not completed
      if (!myReviewer.completedAt && employeeId === myReviewer.employee.id) {
        await skillsApi.updateSkillSegmentMappingComments(
          reviewerId,
          mappingId,
          value
        );

        setCompetencies(prev => ({
          ...prev,
          reviewers: {
            ...prev.reviewers,
            [reviewerId]: {
              ...prev.reviewers[reviewerId] || {},
              skills: {
                ...prev.reviewers[reviewerId]?.skills || {},
                [skillId]: {
                  ...prev.reviewers[reviewerId]?.skills?.[skillId] || {},
                  segments: {
                    ...prev.reviewers[reviewerId]?.skills?.[skillId]?.segments || {},
                    [segmentId]: {
                      ...prev.reviewers[reviewerId]?.skills?.[skillId]?.segments?.[segmentId] || {},
                      comments: value
                    }
                  }
                }
              }
            }
          }
        }));
        
        return Promise.resolve(); // Return resolved promise on success
      }
      return Promise.resolve(); // Still resolve if we didn't need to save
    } catch (error) {
      console.error('Error updating segment comments:', error);
      showAlert(error.message || 'Failed to save segment comments', 'error', error);
      return Promise.reject(error); // Reject promise on error
    }
  };

  return {
    handleCommentChange,
    handleSegmentCommentChange
  };
};

export default useCommentsManagement; 